<template>
  <div class="page-container password-page">
    <el-card class="password-card" shadow="never">
      <div class="password-title">修改密码</div>
      <div class="password-desc">修改成功后需使用新密码重新登录</div>
      <el-form
        ref="passwordForm"
        :model="form"
        :rules="rules"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="form.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="form.newPassword"
            type="password"
            placeholder="6-20 位，建议字母 + 数字组合"
            show-password
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            maxlength="20"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="submit-btn"
            :loading="submitting"
            @click="submit"
          >确认修改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// 修改密码（顶栏头像下拉入口，不进侧边栏菜单）
// 接口：POST /mine/change/password，入参 { old_password, new_password, confirm_password }
//   （新密码 6-20 位、不能与原密码相同、两次输入必须一致；三项服务端都会再校一遍，前端校验只为体验）
// 后端改密成功后会把当前 token 加入黑名单，前端必须清登录态回登录页
import { changePassword } from '@/api/mine'

export default {
  name: 'MinePassword',
  data() {
    return {
      submitting: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度 6-20 位', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && value === this.form.oldPassword) {
                callback(new Error('新密码不能与原密码相同'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return
        this.submitting = true
        changePassword({
          old_password: this.form.oldPassword,
          new_password: this.form.newPassword,
          confirm_password: this.form.confirmPassword
        }).then(res => {
          if (res.code !== 200) return
          this.$message.success('密码修改成功，请重新登录')
          this.$store.dispatch('logout')
          this.$router.push('/login')
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped>
.password-page {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}
.password-card {
  width: 420px;
  align-self: flex-start;
  border-radius: 10px;
}
.password-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-100, #303133);
  text-align: center;
}
.password-desc {
  font-size: 12px;
  color: #909399;
  text-align: center;
  margin: 6px 0 18px;
}
.submit-btn {
  width: 100%;
}
</style>
